import analysis from './ja-JP/analysis';
import app from './ja-JP/app';
import common from './ja-JP/common';
import component from './ja-JP/component';
import dashboard from './ja-JP/dashboard';
import data from './ja-JP/data';
import globalHeader from './ja-JP/globalHeader';
import landing from './ja-JP/landing';
import menu from './ja-JP/menu';
import org from './ja-JP/org';
import pwa from './ja-JP/pwa';
import settingDrawer from './ja-JP/settingDrawer';
import settings from './ja-JP/settings';
import system from './ja-JP/system';
import user from './ja-JP/user';

export default {
  'navBar.lang': '言語',
  'layout.user.link.help': 'ヘルプ',
  'layout.user.link.privacy': 'プライバシー',
  'layout.user.link.terms': '利用規約',
  'app.preview.down.block': 'このページをローカルプロジェクトにダウンロードしてください',
  'app.welcome.link.fetch-blocks': '',
  'app.welcome.link.block-list': '',
  ...user,
  ...landing,
  ...menu,
  ...dashboard,
  ...app,
  ...data,
  ...analysis,
  ...org,
  ...system,
  ...common,
  ...globalHeader,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
};
